import { render, staticRenderFns } from "./BiddingDetail.vue?vue&type=template&id=1b459cfa&scoped=true"
import script from "./BiddingDetail.vue?vue&type=script&lang=js"
export * from "./BiddingDetail.vue?vue&type=script&lang=js"
import style0 from "./BiddingDetail.vue?vue&type=style&index=0&id=1b459cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b459cfa",
  null
  
)

export default component.exports